<template>
  <div id="app">
    <div class="container is-fluid" style="margin: 0 !important;background: rgba(0, 0, 0, 0.85);overflow: hidden;height: 100vh;">
      <!-- <div class="notification">
        This container is <strong>fullwidth</strong> <em>until</em> the <code>$fullhd</code> breakpoint.
      </div> -->
      <div class="columns is-gapless">
        <div v-if="false" class="column is-one-quarter" style="overflow: overlay;height: 100vh;position: relative;">
          <div class="field" style="position: fixed;width: inherit;z-index: 2;">
            <!-- <label class="label">Name</label> -->
            <div class="control" style="text-align: center;">
              <input class="input is-large" type="text" @keyup.13="searchVideo($event.target.value);" placeholder="Buscar"
                      style="width: 95%;margin: 15px auto;">
            </div>
          </div>
          <div class="listResult" style="margin-top: 93px;">
            <template v-if="searchList === 'none'">
              <h2 style="color: rgba(255,255,255,0.85);">No se encontraron resultados</h2>
            </template>
            <template v-else-if="searchList.length === 0 && searchBar === true">
              <progress class="progress is-primary is-medium" v-bind:value="searchProgress" max="100"></progress>
            </template>

            <template v-else>
              <div v-for="video in searchList" class="videoContainer" style="margin-bottom: 20px;width: 97%;">
                <div class="videoDescription" style="margin-bottom:5px;">
                  <h2 class="videoName subtitle" style="color: rgba(255,255,255,0.85);">{{ video.snippet.title }}</h2>
                </div>
                <img :src="video.snippet.thumbnails.medium.url"  class="videoImage">
                <div class="tags has-addons tags-videos">
                  <span @click="playVideo(video)" class="tag is-pointer is-medium">
                    <span class="icon">
                      <i class="fa fa-play"></i>
                    </span> Play Now</span>
                  <span @click="addVideo(video, $event.target)" class="tag is-pointer is-primary is-medium">
                    <span class="icon">
                      <i class="fa fa-plus-circle"></i>
                    </span> Add to list</span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="column">
          <template v-if="movie.length === 0">
            <youtube v-if="lastVideo.length !== 0" @ready="ready" :video-id="lastVideo[0].videoId" :player-vars="{ autoplay: 1 }" @ended="endVideo(playList[0])"/>
          </template>
          <template v-else>
            <video id="clip" controls="controls" autoplay="true">
              <source v-bind:src="lastVideo[0].src" type="video/mp4">
            </video>
          </template>
        </div>
      </div>
    </div>


    <transition name="bounce">
      <div v-if="showAlert" class="notification position-alert is-primary">
        <button class="delete"></button>
        Se agregó la canción <strong> {{ playList[playList.length - 1].title }} </strong>
      </div>
    </transition>


  </div>
</template>

<script>
import Firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyBUDFWeu55JuHEFDI4YQrGBXFM1JL9W1MA',
  authDomain: 'taquitos-chat.firebaseapp.com',
  databaseURL: 'https://taquitos-chat.firebaseio.com/',
  storageBucket: 'taquitos-chat.appspot.com',
  messagingSenderId: '588166412136',
};

const firebaseApp = Firebase.initializeApp(config);
const db = firebaseApp.database();
let gapi;
// const userId = `wubba-${Math.round(Math.random() * 100000)}`;
export default {
  name: 'app',
  data() {
    return {
      showAlert: false,
      searchBar: false,
      searchList: [],
      searchProgress: 0,
    };
  },

  firebase: {
    listVideo: db.ref('videos/'),
    playList: db.ref('playList/'),
    lastVideo: db.ref('videos/').limitToLast(1),
    amOnline: db.ref('.info/connected'),
    movie: db.ref('movie/').limitToLast(1),
  },

  mounted() {
    window.youtubeReady = (g) => {
      gapi = g;
    };

    this.$firebaseRefs.playList.limitToLast(1).on('child_added', () => {
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 1500);
    });

    window.showMovie = (movie) => {
      this.$firebaseRefs.movie.push({
        src: movie,
      });
    };
  },
  methods: {
    ready(player) {
      this.player = player;
    },

    searchVideo(name) {
      this.searchList = [];
      this.searchBar = true;
      this.searchProgress = 0;

      const request = gapi.client.youtube.search.list({
        part: 'snippet',
        type: 'video',
        q: encodeURIComponent(name).replace(/%20/g, '+'),
        videoEmbeddable: true,
        videoSyndicated: true,
        maxResults: 15,
      });

      request.execute((response) => {
        const increaseProgress = setInterval(() => {
          this.searchProgress += 1;
          if (this.searchProgress === 100) {
            clearInterval(increaseProgress);
            if (response.result.items.length === 0) {
              this.searchList = 'none';
            } else {
              this.searchList = response.result.items;
            }
          }
        }, 0.3);
      });
    },

    playVideo(video) {
      const title = video.snippet.title;
      const videoId = video.id.videoId;
      this.$firebaseRefs.listVideo.push({
        videoId,
        title,
      });
    },

    addVideo(video, elm) {
      const title = video.snippet.title;
      const videoId = video.id.videoId;

      // eslint-disable-next-line
      elm.style.display = 'none';

      this.$firebaseRefs.playList.push({
        videoId,
        title,
      });
    },

    endVideo(video) {
      if (this.playList.length > 0) {
        this.$firebaseRefs.listVideo.push({
          videoId: video.videoId,
          title: video.title,
        });
        this.$firebaseRefs.playList.child(this.playList[0]['.key']).remove();
      }
    },
  },
};
</script>

<style>
iframe {
  width: 100vw;
  height: 100vh;
}
/*Transitions*/
.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
/*******HIDEN SCROLLBARS ********/
::-webkit-scrollbar {
  display: none;
}
/*******************************/
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin-top: 60px;*/
}
#youtube-player-1 {
  width: 100%;
  height: 100vh;
  /*height: 50vh;*/
}

progress {
  transition: all 0.1s ease;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -10px 0 0 -232px;
  width: 97% !important;
}

.iframe-movie {
  width:100vw;
  height:100vh;
}

.listResult {
  text-align: center;
}

.tags-videos {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -118.5px;
  margin-bottom: -1px !important;
}

.is-pointer {
  cursor: pointer;
}

.videoContainer {
  position: relative;
}

.position-alert {
  position: absolute;
  top: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// App.vue?1d107d1c